import { render, staticRenderFns } from "./Recruitment.vue?vue&type=template&id=190545a0&scoped=true&"
import script from "./Recruitment.vue?vue&type=script&lang=js&"
export * from "./Recruitment.vue?vue&type=script&lang=js&"
import style0 from "./Recruitment.vue?vue&type=style&index=0&id=190545a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190545a0",
  null
  
)

export default component.exports